import React, { useState, useEffect } from 'react';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import Slider from "react-slick";
import { Container } from 'reactstrap';
import { LargeBusiness, moduleMargins, htmlWidget } from '../../Constants';
import EirButton from '../eir-button/EirButton';


import Constants from '../../Constants';

import Dom from '../../utils/Dom'

function ContentCarousel(props) {

  const renderContent = (content) => {
    return { __html: content };
  }

  useEffect(() => {
    //id for carousel arrows
    let getArrows = document.querySelectorAll(".slick-arrow");
    for (var cnt = 0; cnt < getArrows.length; cnt++) {
      // (getArrows[cnt].classList.contains("slick-prev")) ? (getArrows[cnt].setAttribute("id", "content-carousel_arrow_prev"), getArrows[cnt].setAttribute("title", "Previous")) : (getArrows[cnt].setAttribute("id", "content-carousel_arrow_next"), getArrows[cnt].setAttribute("title", "Next"))
      if (getArrows[cnt].classList.contains("slick-prev")) {
        getArrows[cnt].setAttribute("id", "content-carousel_arrow_prev");
        getArrows[cnt].setAttribute("title", "Previous");
        var tmpBtn = document.createElement("button");
        tmpBtn.title = "Prev";
        tmpBtn.addEventListener("focus", function () {
          tmpBtn.parentNode.focus();
        })
        getArrows[cnt].appendChild(tmpBtn);
        tmpBtn.addEventListener("click", function () {
          tmpBtn.blur();
        })
      }
      else {
        getArrows[cnt].setAttribute("id", "content-carousel_arrow_next");
        getArrows[cnt].setAttribute("title", "Next");
        var tmpBtn = document.createElement("button");
        tmpBtn.title = "Next";
        tmpBtn.addEventListener("focus", function () {
          tmpBtn.parentNode.focus();
        })
        getArrows[cnt].appendChild(tmpBtn);
        tmpBtn.addEventListener("click", function () {
          tmpBtn.blur();
        })

      }
    }
    // var tmp = document.querySelector("#content-carousel_arrow_next");
    // var tmpBtn = document.createElement("button");
    // // tmpBtn.setAttribute("title", "nextt");
    // tmpBtn.addEventListener("focus", function () {
    //   console.log(tmpBtn.parentNode);
    //   tmpBtn.parentNode.focus();

    //   tmp.appendChild(tmpBtn);
    //   tmpBtn.addEventListener("click", function () {

    //     tmpBtn.blur();
    //   })
  })

  Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
  Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);

  //custom arrow for slides
  function CustomArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, zIndex: "1000" }}
        onClick={onClick}
      > &lt;
      </div>
    );
  }

  //configuration for slides in desktop
  const settingsModules = (!LargeBusiness.isLBSite? 
  {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />
  }
  :
  {
    slidesToShow: props.desktopTiles.length>4?5:4,
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed:5000,
    responsive: [
      {
        breakpoint: 1184,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 716,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 482,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]  
  });

  //configuration for slides in mobile
  const mobileSettingsModules = (!LargeBusiness.isLBSite?
    {
    infinite: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />
    }
    :
    {
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />,

    infinite: true,
    autoplay: true,
    autoplaySpeed:5000,
    responsive: [
      {
        breakpoint: 853,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 619,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ] 
    });

  const props_tiles = props.desktopTiles.filter(item => item);
  const props_mobileTiles = props.mobileTiles.filter(item => item);

  //tile content for desktop
  const slides = props_tiles.map((item, i) =>
    <div key={i} >
      {item.image &&
        <div className="cc-tile">
          <img src={item.image.path} alt={item.altText} className={"wh-img-content-carousel m-2"+ (!LargeBusiness.isLBSite? " content-carousel-tile":"")} />
          {LargeBusiness.isLBSite && <div className={"tile-title " + htmlWidget} dangerouslySetInnerHTML={renderContent(item.title)}></div>}
          <div className={ htmlWidget + (LargeBusiness.isLBSite? "tile-text-lb" : "tile-text")} dangerouslySetInnerHTML={renderContent(item.text)}></div>
        </div>
      }
    </div>
  );

  //tile content for mobile
  const mobileSlides = props_mobileTiles.map((item, i) =>
    <div key={i} >
      {item.image &&
        <div className="cc-tile">
          <img src={item.image.path} alt={item.altText} className={"wh-img-content-mobile-carousel mx-auto mt-3 mb-3"+ (!LargeBusiness.isLBSite? " content-carousel-tile":"")} />
          {LargeBusiness.isLBSite && <div className={"tile-title " + htmlWidget} dangerouslySetInnerHTML={renderContent(item.title)}></div>}
          <div className={htmlWidget + (LargeBusiness.isLBSite? "tile-text-lb" : "tile-text mobile-tile-text")} dangerouslySetInnerHTML={renderContent(item.text)}></div>
        </div>
      }
    </div>
  );
  let [marginDesktop, marginMobile] = moduleMargins(props.MarginDT, props.MarginMobile);
  
  
  return (
    <div>
      {(!isMobile || isTablet) && props_tiles.length > 3 &&
        <div className={'pt-4 pb-5 content-carousel '+ ((!isMobileOnly) ? marginDesktop : marginMobile) + (LargeBusiness.isLBSite? " content-carousel-lb": "")} style={{
          backgroundColor: props.backgroundColor
        }} >
          <div className={`homepage-modules-title container ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(props.moduleTitle)}></div>
          <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
            <div>
              <Slider {...settingsModules} className="pt-4 justify-content-center align-items-center">
                {slides}
              </Slider>
              {(props.desktopBottomCTA != undefined) && <div className="text-center">
                <EirButton  {...props.desktopBottomCTA} databundlecode='Content carousel CTA 1'
                  outline={true}
                  className="mt-4 js-prequal-modal-btn eir-text-secondary ls-0 p-2 cta_threesix"
                />
              </div>}
            </div>
          </Container>
        </div>
      }

      {isMobile && !isTablet && props_mobileTiles.length > 3 &&
        <div className={'pt-4 pb-5 content-carousel '+ ((!isMobileOnly) ? marginDesktop : marginMobile) + (LargeBusiness.isLBSite? " content-carousel-lb-m": "")} style={{
          backgroundColor: props.backgroundColor
        }} >
          <div className={`homepage-modules-title container ${htmlWidget}`} dangerouslySetInnerHTML={renderContent(props.moduleTitle)}></div>
          <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
            <div>
              <Slider {...mobileSettingsModules} className="">
                {mobileSlides}
              </Slider>
              {(props.mobileBottomCTA != undefined) && <div className="text-center">
                <EirButton  {...props.mobileBottomCTA} databundlecode='Content carousel CTA 1'
                  outline={true}
                  className="mt-5 js-prequal-modal-btn eir-text-secondary ls-0 p-2 cta_threesix"
                />
              </div>}
            </div>
          </Container>
        </div>
      }
    </div>
  );
}

export default ContentCarousel
